<template>
  <div class="mt-3">
    <b-button
      data-cy="show-filters-button"
      v-b-toggle.collapse-1 variant="primary"
      size="sm"
    >
      Filtros rápidos
    </b-button>
    <b-collapse id="collapse-1" class="mt-2">
      <b-card>
        <div class="row">
          <div class="col-4">
            <b-form-group label="Institución remitente">
              <b-input-group>
                <b-form-input
                  data-cy="filter-sender"
                  placeholder="Institución remitente"
                  name="filterSender"
                  v-model="filters.sender"
                  @input="onInput"
                />
              </b-input-group>
            </b-form-group>
          </div>
          <div class="col-4">
            <b-form-group label="Folio">
              <b-input-group>
                <b-form-input
                  placeholder="Folio"
                  data-cy="filter-number"
                  name="filterNumber"
                  v-model="filters.number"
                  @input="onInput"
                />
              </b-input-group>
            </b-form-group>
          </div>
          <div class="col-4">
            <b-form-group label="Tipo de documento">
              <v-select
                data-cy="select-doc-types-filters"
                name="type"
                :options="listOptions"
                v-model="filters.type"
                :class="{ 'v-select-danger': danger }"
                placeholder="Tipo de documento"
                @input="onInput"
                :reduce="option => option.value"
              >
                <template #spinner>
                  <b-spinner
                    small
                    v-if="loading"
                    :style="{ opacity: loading ? 1 : 0 }"
                    variant="primary"
                  />
                </template>
              </v-select>
            </b-form-group>
          </div>
          <div class="col-12 text-right">
            <b-button
              size="sm"
              @click="clearFilters()"
              data-cy="clear-filters-button"
            >
              limpiar
            </b-button>
          </div>
        </div>
      </b-card>
    </b-collapse>
  </div>
</template>
<script>
import {mapActions, mapGetters} from 'vuex';
import { mergeFilters } from '@/febos/chile/dnt/utils/fitlers';

export default {
  data() {
    return {
      rowspp: Number.parseInt(this.$route.query.paginate || 10, 10),
      loading: false,
      filters: {
        number: '',
        sender: '',
        type: ''
      },
      options: []
    };
  },
  computed: {
    ...mapGetters('List', [
      'documentTypesExternalsState'
    ]),
    optionSelected() {
      return this.options.find((option) => option.value === this.value);
    },
    isDisabled() {
      return this.disabled || !this.options.length || this.loading;
    },
    listOptions() {
      return this.documentTypesExternalsState.list;
    }
  },
  methods: {
    ...mapActions('List', [
      'fetchDocumentTypesExternals'
    ]),
    ...mapActions('Dnts', [
      'listDocuments',
    ]),
    getFilters() {
      // Esta condición es para ver referencias en base a febosId
      return mergeFilters(this.filtersFiles, this.$route.query.filters);
    },
    async onInput() {

      const FILTERS_MAPPER = {
        sender: 'emisorContactoArea',
        number: 'numero',
        type: 'emisorCentroCostoNumero'
      };
      const filters = Object.entries(this.filters)
        .filter(([, value]) => !!value)
        .map(([key, value]) => (
          `${FILTERS_MAPPER[key]}$${value}`
        ))
        .join('|');

      const query = {
        params: {
          tipo: 'EXP',
          campos: '*',
          pagina: 1,
          orden: '-fechaCreacion',
          elementosPorPagina: this.rowspp,
          filtros: this.getFilters() + '|' + filters
        }
      };
      await this.listDocuments(query);
      this.loading = false;
    },
    clearFilters() {
      this.filters = {
        number: '',
        sender: '',
        type: ''
      }
    }
  },
  created() {
    this.fetchDocumentTypesExternals();
  },
  props: {
    placeholder: String,
    autocomplete: { type: Boolean, default: false },
    value: { type: String },
    danger: { type: Boolean },
    filtersFiles: { type: String },
  }
}
</script>
